import { render } from "./ReportCriterionSelect.vue?vue&type=template&id=6bc9567a&scoped=true"
import script from "./ReportCriterionSelect.vue?vue&type=script&lang=js"
export * from "./ReportCriterionSelect.vue?vue&type=script&lang=js"

import "./ReportCriterionSelect.vue?vue&type=style&index=0&id=6bc9567a&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/gmX3YL_q/0/internal/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc9567a"]])

export default __exports__